module.exports = __webpack_public_path__ + "img/provider_championship.da46e7c0.svg";